import styled from 'styled-components';
import { useSelectedCollectedOrderDataValueContextHook } from '../../contexts/SelectedCollectedOrderDataContext';
import { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { RefExcelTranslatorHeaderApi } from '../../../../../apis/RefExcelTranslatorHeaderApi';
import { CustomDateUtils } from '../../../../../utils/CustomDateUtils';
import { MapperUtils } from '../../utils/MapperUtils';

// TODO : 발송지연 데이터 가져와야되는데 해당 부분 확인해보기
const StyledContainer = styled.div`
    padding: 10px;
`;

const TableContainer = styled.div`
  overflow-x: auto;
  margin: 0;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  width: 100%;
  max-height: 500px;
  border: 1px solid #efefef;
`

const StyledTable = styled.table`
  table-layout: auto;    /* 내용 길이에 맞춰 열 너비 자동 */
  white-space: nowrap;   /* 한 줄로 표시하여 열이 자동 확장 */
  border-collapse: collapse;
  background-color: #ffffff;

  /* width: 100%;  <-- 필요한 경우 제거하거나 조정
     min-width: 800px; <-- 원한다면 유지 (너무 좁아지지 않게)
  */
`;

const TableHeader = styled.thead`
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f8f9fa;
`

const TableHeaderCell = styled.th`
    padding: 16px;
    text-align: left;
    font-weight: 600;
    color: #495057;
    border-bottom: 2px solid #dee2e6;
    white-space: nowrap;
    font-size: 14px;
`

const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f8f9fa;
  }

  &:hover {
    background-color: #e9ecef;
  }
`

const TableCell = styled.td`
  padding: 16px;
  color: #495057;
  border-bottom: 1px solid #dee2e6;
  font-size: 14px;
`

export function WegetCollectedTable(props) {
    const selectedCollectedOrderDataValueContextHook = useSelectedCollectedOrderDataValueContextHook();

    const [refExcelTranslatorHeaderDetailList, setRefExcelTranslatorHeaderDetailList] = useState([]);
    const [temporaryErpItems, setTemporaryErpItems] = useState([]);

    const commerceApiStoreInfo = selectedCollectedOrderDataValueContextHook?.selectedCollectedOrderData?.commerceApiStoreInfo;
    const newOrders = selectedCollectedOrderDataValueContextHook?.selectedCollectedOrderData?.newOrders;

    useEffect(() => {
        async function fetchRefExcelTranslatorHeader() {
            const fetchResult = await RefExcelTranslatorHeaderApi().searchLatest({ params: null, headers: null })
            if (fetchResult?.content) {
                setRefExcelTranslatorHeaderDetailList(fetchResult?.content?.refExcelTranslatorHeaderDetailList);
            }
        }
        fetchRefExcelTranslatorHeader();
    }, [])

    useEffect(() => {
        if (!selectedCollectedOrderDataValueContextHook?.selectedCollectedOrderData?.commerceApiStoreInfo?.id) {
            setTemporaryErpItems([]);
            return;
        }

        const mappedOrderData = MapperUtils().getMappedOrderData({ orders: newOrders, salesChannel: commerceApiStoreInfo?.storeName, workspaceId: null });
        setTemporaryErpItems(mappedOrderData);
    }, [selectedCollectedOrderDataValueContextHook?.selectedCollectedOrderData?.commerceApiStoreInfo?.id]);

    return (
        <>
            <StyledContainer>
                <TableContainer>
                    <StyledTable>
                        <TableHeader>
                            <tr>
                                {refExcelTranslatorHeaderDetailList?.map((refExcelTranslatorHeaderDetail, index) => (
                                    <TableHeaderCell key={refExcelTranslatorHeaderDetail?.id}>{refExcelTranslatorHeaderDetail?.headerName}</TableHeaderCell>
                                ))}
                            </tr>
                        </TableHeader>
                        <tbody>
                            {temporaryErpItems.map((data, rowIndex) => {
                                return (
                                    <TableRow key={rowIndex}>
                                        {refExcelTranslatorHeaderDetailList.map((refExcelTranslatorHeaderDetail, headerIndex) => {
                                            if (refExcelTranslatorHeaderDetail.fieldName === 'channelOrderDate') {
                                                return (
                                                    <TableCell key={headerIndex}>{CustomDateUtils().dateToYYYYMMDDhhmmss(data[refExcelTranslatorHeaderDetail.fieldName])}</TableCell>
                                                );
                                            }
                                            return (
                                                <TableCell key={headerIndex}>{data[refExcelTranslatorHeaderDetail.fieldName]}</TableCell>
                                            );
                                        })}
                                    </TableRow>
                                );
                            }
                            )}
                        </tbody>
                    </StyledTable>
                </TableContainer>
            </StyledContainer>
        </>
    );
}